import React from "react";
import { Image } from "react-bootstrap";

let stampCounter = 0;

const VintageStamp = ({ history = [] }) => {
  const stampId = React.useMemo(() => `vintage-${++stampCounter}`, []);

  const entries = history.filter(
    (h) =>
      h.pv_status === "DAG Approved" ||
      h.pv_status === "Director Expenditure Control Approved"
  );

  if (entries.length === 0) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
      return new Date(dateStr).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  const stampText = (status) => {
    if (status === "DAG Approved") return "DAG APPROVED";
    if (status === "Director Expenditure Control Approved")
      return "DIRECTOR EC APPROVED";
    return status.toUpperCase();
  };

  return (
    <>
      <svg style={{ position: "absolute", width: 0, height: 0 }}>
        <defs>
          <filter id={`distress-${stampId}`}>
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.05"
              numOctaves="3"
              result="noise"
            />
            <feDisplacementMap
              in="SourceGraphic"
              in2="noise"
              scale="2"
              xChannelSelector="R"
              yChannelSelector="G"
              result="displaced"
            />
            <feComposite
              in="displaced"
              in2="SourceGraphic"
              operator="in"
            />
          </filter>
        </defs>
      </svg>

      <div
        style={{
          position: "absolute",
          top: 10,
          right: 40,
          display: "flex",
          flexDirection: "column",
          gap: 8,
          zIndex: 100,
          pointerEvents: "none",
        }}
      >
        {entries.map((entry, i) => (
          <div
            key={i}
            style={{
              transform: "rotate(-14deg)",
              filter: `url(#distress-${stampId})`,
            }}
          >
            <div
              style={{
                backgroundColor: "rgba(255,255,255,0.08)",
                padding: "8px 14px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: 160,
              }}
            >
              <span
                style={{
                  color: "#C41E3A",
                  fontSize: 13,
                  fontWeight: 900,
                  fontFamily:
                    '"Impact", "Arial Black", "Roboto Slab", sans-serif',
                  letterSpacing: 2,
                  textAlign: "center",
                  textTransform: "uppercase",
                  lineHeight: 1.2,
                  borderBottom: "2px solid #C41E3A",
                  paddingBottom: 4,
                  marginBottom: 4,
                  width: "100%",
                }}
              >
                {stampText(entry.pv_status)}
              </span>

              {entry.fullname && (
                <span
                  style={{
                    color: "#C41E3A",
                    fontSize: 11,
                    fontWeight: "bold",
                    fontFamily: '"Courier New", monospace',
                    textAlign: "center",
                    textTransform: "uppercase",
                    lineHeight: 1.3,
                  }}
                >
                  {entry.fullname}
                </span>
              )}

              {entry.signature && (
                <Image
                  src={entry.signature}
                  style={{
                    width: 50,
                    height: 25,
                    marginTop: 2,
                    objectFit: "contain",
                  }}
                />
              )}

              {entry.updated_at && (
                <span
                  style={{
                    color: "#C41E3A",
                    fontSize: 9,
                    fontFamily: '"Courier New", monospace',
                    textAlign: "center",
                    marginTop: 2,
                    opacity: 0.85,
                  }}
                >
                  {formatDate(entry.updated_at)}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default VintageStamp;
